export default __webpack_public_path__ + "static/media/notok-texte-complet-664x830.f0ff4285.jpg";